module.exports = __webpack_public_path__ + "img/EmptyPage.8854be59.svg";